import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { GitBranch, Bot, Brain } from "lucide-react";
import Flows from "../Flows";
import Automations from "../Automations";
import Copilot from "../Copilot";
import { SectionHeader } from "./Capture";

const TABS = [
  { id: "flows", label: "Live Flows", icon: GitBranch, comp: Flows, hint: "Operational funnel — leads → revenue" },
  { id: "workforce", label: "Workforce", icon: Bot, comp: Automations, hint: "Hunter · Closer · Recovery · Insight · Growth" },
  { id: "strategist", label: "Strategist", icon: Brain, comp: Copilot, hint: "Decision-grade revenue strategist" },
  // Back-compat alias: ?tab=agents → Workforce
  { id: "agents", label: "Workforce", icon: Bot, comp: Automations, hint: "Hunter · Closer · Recovery · Insight · Growth", hidden: true },
];

export default function Convert() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") || "flows";
  const [tab, setTab] = useState(initial);
  const Active = TABS.find(t => t.id === tab)?.comp || Flows;
  const meta = TABS.find(t => t.id === tab);

  return (
    <div data-testid="convert-page">
      <SectionHeader title="Convert" subtitle="Where pipeline becomes revenue — operated for you" tabs={TABS.filter(t => !t.hidden)} active={tab === "agents" ? "workforce" : tab}
        onChange={(id) => { setTab(id); setParams({ tab: id }); }} hint={meta?.hint} />
      <Active />
    </div>
  );
}
